import { ThemedComponentProps } from '../theme.types'

/**
 * Functions transforms/generates values for CSS properties
 */

/** Creates px based value */
export function px(value: number): string {
  return `${value}px`
}

/** Creates rem based value */
export function createRem(value: number, base: number): string {
  return `${value / base}rem`
}

/** Creates spacer */
export function createSpacing(multiplier: number, base: number): number {
  return base * multiplier
}

/** Calculates pixel value as rem */
export const rem = (value: number) => (props: ThemedComponentProps) => createRem(value, props.theme.remBase)

/** Calculates spacing in rem units */
export const spacing =
  (multiplier = 1) =>
  (props: ThemedComponentProps) =>
    createRem(createSpacing(multiplier, props.theme.spaceBase), props.theme.remBase)
